import ReactDOM from "react-dom";
import UtilService from "../../service/UtilService";

const PromoteWeightsModal = ({ changes, onCancel, onConfirm, saving }) => {
  return ReactDOM.createPortal(
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget && !saving) onCancel();
      }}
    >
      <div className="modal-box" style={{ fontSize: "0.85em" }}>
        <h3>Promote weights to live config</h3>

        <p style={{ margin: "0 0 12px", color: "#555" }}>
          This immediately replaces the live configuration used for real
          transaction scoring. The changed weights take effect right away for
          all traffic. The changed weights below will be marked as{" "}
          <strong>manually set</strong>. Do you want to promote now?
        </p>

        <table
          className="config-table"
          style={{ width: "100%", tableLayout: "fixed" }}
        >
          <colgroup>
            <col />
            <col style={{ width: "80px" }} />
            <col style={{ width: "80px" }} />
          </colgroup>
          <thead>
            <tr>
              <th>Rule</th>
              <th>Current</th>
              <th>New</th>
            </tr>
          </thead>
          <tbody>
            {changes.map(({ key, current, next }) => (
              <tr key={key}>
                <td
                  title={key}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {UtilService.camelCaseToReadable(key)}
                </td>
                <td className="gray">{current}</td>
                <td>
                  <strong>{next}</strong>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="modal-actions">
          <span style={{ marginRight: "auto", color: "#555" }}>
            {changes.length} weight{changes.length === 1 ? "" : "s"} changed
          </span>
          <button onClick={onCancel} disabled={saving}>
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={saving}
            style={{
              backgroundColor: "#e67e22",
              borderColor: "#e67e22",
              color: "#fff",
            }}
          >
            {saving ? "Promoting…" : "⚠ Promote"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default PromoteWeightsModal;
